/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environments';
import { AuthenticationService } from '../../../services/authentication.service';
import { SharedModule } from '../../shared/shared.moudle';
import { switchMap, map } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-consent',
  standalone: true,
  imports: [
    SharedModule
  ],
  templateUrl: './consent.component.html',
  styleUrl: './consent.component.scss'
})
export class ConsentComponent implements OnInit {
  token: any
  type: any
  isAccpect = false
  isReject = false
  isExpired = false
  isError = false
  isLoading = true
  id: string | any
  pwa_url: string = environment.pwa_url
  parent_password_generated = false
  isProcessing: boolean = false;


  constructor(
    private route: ActivatedRoute,
    private auth: AuthenticationService,
    private router: Router,
    private toastr: ToastrService
  ) { }

  @HostListener('window:offline')
  onOffline() {
    if (this.isProcessing) {
      this.isProcessing = false;
      this.toastr.error("No internet connection. Please check your network and try again.", 'No Internet', {
        progressBar: true,
        closeButton: true
      });
    }
  }

  @HostListener('window:online')
  onOnline() {
    this.toastr.success("You're back online. You can try again.", 'Connected', {
      progressBar: true,
      closeButton: true
    });
  }

  // ngOnInit(): void {
  //   this.token = this.route.snapshot.paramMap.get('token')
  //   this.type = this.route.snapshot.paramMap.get('type')
  //   this.isAccpect = this.type.toLowerCase() === "agree"
  //   this.isReject = !this.isAccpect
  //   this.auth.verifyToken(this.token).subscribe((res: any) => {
  //     if (res["token"] === "expired") {
  //       //
  //     } else {
  //       // const user =res['token']["Claims"]["id"];
  //       this.auth.changeParentConsent(res['token']["Claims"]["academy"], this.isAccpect, res['token']["Claims"]["id"]).subscribe(() => {
  //         // console.log(this.token
  //       })

  //       // const mass_recpnt_list = (this.recepientlist || [])
  //       const academy = res['token']["Claims"]["academy"];
  //       const childId = res['token']["Claims"]["id"];
  //       this.membership.getMembersByType(academy, "coach", "0", "","active", "", 30).subscribe({
  //         next: (res: any) => {
  //           const coaches = res.members;
  //           const mass_recpnt_list = coaches.map((c: any) => c._id);
  //           this.auth.fetchUserData(childId).subscribe({
  //             next:(parent: any)=>{
  //               const parent_info = parent.data
  //               const name = parent_info?.basic_information?.name?.first_name || 'A student'
  //               const message = `Alert: Parental Consent has been ${this.isAccpect ? 'Accepted' : 'Rejected'} by parent for child ${name}.`;
  //               const header = `Parental Consent ${this.isAccpect ? 'Accepted' : 'Rejected'}`;
  //               const recipientId = mass_recpnt_list[0] || this.id;
  //               if (mass_recpnt_list.length > 0) {
  //                 console.log("Sending notification to coaches:", mass_recpnt_list);
  //                 this.notification.sendPushNotification(
  //                   mass_recpnt_list,
  //                   message,
  //                   recipientId,
  //                   academy,
  //                   ACTION_IDS.Assign,
  //                   TARGET_IDS.General,
  //                   NOTIFICATION_TYPES.NewMessage,
  //                   header,
  //                   true,
  //                   NOTIFICATION_TAGS.GENERAL
  //                 )
  //               }

  //               console.log("Student:",parent_info)
  //               console.log("Student:",
  //                   mass_recpnt_list,
  //                   message,
  //                   recipientId,
  //                   academy,
  //                   ACTION_IDS.Assign,
  //                   TARGET_IDS.General,
  //                   NOTIFICATION_TYPES.NewMessage,
  //                   header,
  //                   true,
  //                   NOTIFICATION_TAGS.GENERAL
  //               )
  //             }
  //           })
  //         }
  //       });
  //       this.auth.fetchUserId(res['token']["Claims"]["username"]).subscribe({
  //         next:(res: any)=>{
  //           this.auth.fetchUserData(res.id).subscribe({
  //             next:(parent: any)=>{
  //               const parent_info = parent.data
  //               if(parent_info.active_status === "new"){
  //                 this.goToPasswordGen()
  //               }else{
  //                 this.parent_password_generated = true
  //               }
  //             }
  //           })
  //         }
  //       })
  //       // setTimeout(() => {
  //       //   this.router.navigate(['/user/reset/', this.token,"generate"]);
  //       // }, 2000);
  //     }
  //   })
  // }

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token');
    this.type = this.route.snapshot.paramMap.get('type') || '';

    if (!this.token || !this.type) {
      this.isLoading = false;
      this.isError = true;
      this.toastr.error("This consent link is invalid.", 'Invalid Link', {
        progressBar: true,
        closeButton: true
      });
      return;
    }

    this.isAccpect = this.type.toLowerCase() === 'agree';
    this.isReject = !this.isAccpect;

    this.auth.verifyToken(this.token).pipe(

      // 1️⃣ Validate token
      switchMap((res: any) => {
        if (res?.token === 'expired') {
          throw new Error('TOKEN_EXPIRED');
        }

        const claims = res.token.Claims;
        const academy = claims.academy;
        const childId = claims.id;
        const username = claims.username;

        // 2️⃣ Update consent (must happen). The backend enqueues the
        // admin notification as a side effect of recording the consent —
        // this unauthenticated page no longer calls the protected
        // /queue/remind endpoint itself.
        return this.auth
          .changeParentConsent(academy, this.isAccpect, childId)
          .pipe(map(() => ({ username })));
      }),

      // 3️⃣ Resolve the parent user id from the username
      switchMap(({ username }) => this.auth.fetchUserId(username)),

      // 4️⃣ Fetch the parent profile (needed to decide password generation)
      switchMap((parentUserId: any) =>
        this.auth.fetchUserData(parentUserId.id.toString())
      )

    ).subscribe({
      next: (parent: any) => {
        this.isLoading = false;
        this.handleParentPassword(parent);
      },
      error: (err) => {
        this.isLoading = false;
        if (err.message === 'TOKEN_EXPIRED') {
          console.warn('Token expired');
          this.isExpired = true;
          this.toastr.error("This consent link has expired.", 'Link Expired', {
            progressBar: true,
            closeButton: true
          });
          return;
        }
        console.error('Consent flow failed:', err);
        this.isError = true;
        this.toastr.error("Something went wrong while processing your consent. Please try again.", 'Request Failed', {
          progressBar: true,
          closeButton: true
        });
      }
    });
  }

  private handleParentPassword(parentRes: any) {
    const parent = parentRes?.data;

    if (parent?.active_status === 'new') {
      this.goToPasswordGen();
    } else {
      this.parent_password_generated = true;
    }
  }




  goToPasswordGen(){
    if (this.isProcessing) {
      return;
    }
    if (!navigator.onLine) {
      this.toastr.error("No internet connection. Please check your network and try again.", 'No Internet', {
        progressBar: true,
        closeButton: true
      });
      return;
    }
    this.isProcessing = true;
    this.router.navigate(['/user/reset/', this.token,"generate"]);
  }
  login(){
    if (this.isProcessing) {
      return;
    }
    if (!navigator.onLine) {
      this.toastr.error("No internet connection. Please check your network and try again.", 'No Internet', {
        progressBar: true,
        closeButton: true
      });
      return;
    }
    this.isProcessing = true;
    window.location.href = this.pwa_url;
  }
}
